<template>
    <div>
         <div class="info">
                <component :is="componentType" />
         </div>
    </div>
</template>

<script>

//商品详情
import storeList from './StoreList' //商品列表
import storeInfo from './StoreInfo' //商品详情

import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('product')

export default {
    data() {
      return {
         
      }
    },
    components:{storeList,storeInfo},
    mounted(){
       this.componentType
    },
    computed:{
      ...mapState({
         componentType:state=>state.storeType
      })
    },
};
</script>

<style scoped>

.block{
    height: 50px;
}

.demonstration{
    line-height: 50px;
    width: 200px;
}

.bigTitle{
    text-align: left;
}

.floor{
    width: 15px;
    background-color: #0F86DA;
    color:#0F86DA;
    border-radius: 5px;
}

.body{
    background-color: #FFFFFF;
    border-radius: 10px;
}

.table{
    width: 50%;
}

.head th{
    line-height: 50px;
}

.info{
    /* margin-top: 1%; */
    background-color: #FFFFFF;
}

.color{
    background-color: #0F86DA;
    width: 50px;
    height: 50px;
}


.seach-all {
    border-radius:25px;
    display: inline-block;
    margin-top: 10px;
    width: 180px;
    margin-left: 10px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-family: ArialMT;
    font-size: 18px;
    color: #ffffff;
    background-color: #dbe3eb;
  }

  .seach-all:last-child {
    border-right: none;
  }

  .seachchange {
    background-color: #409EFF;
  }

</style>


// WEBPACK FOOTER //
// src/components/Store/Store.vue